import { useContext } from 'react';
import { TeamContext, TeamContextData } from './context';

export function useTeam(): TeamContextData {
    const data = useContext<TeamContextData | undefined>(TeamContext);

    if (!data) {
        throw new Error(
            "TeamContext unavailable. Are you sure you're using this in a nested component of an TeamContextProvider?"
        );
    }

    return {
        team: data.team
    };
}
